import { IconContent } from '@icons';

export const padlockOpened: IconContent = {
    md: '<path d="M7.5 5A2.5 2.5 0 0 1 10 7.5V11H7v9h12v-9h-8V7.5a3.5 3.5 0 1 0-7 0V9h1V7.5A2.5 2.5 0 0 1 7.5 5Zm2.5 7h8v7H8v-7h2Zm3.5 4.914V14h-1v2.914h1Z" />',
};
